"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processTokens = exports.isTokenExpiring = exports.emptyTokenData = exports.decodeToken = void 0;
var _jwtDecode = require("jwt-decode");
var _utils = require("../utils");
const emptyTokenData = function () {
  let tokenDataType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "su20";
  const isLegacy = tokenDataType === "legacy";
  return {
    accessToken: {
      data: null,
      exp: null,
      isLegacy
    },
    refreshToken: {
      data: null,
      exp: null,
      isLegacy
    }
  };
};
exports.emptyTokenData = emptyTokenData;
const isTokenExpiring = (token, expirationThreshold) => {
  if (token.accessToken.isLegacy) {
    return false;
  }
  if (token.accessToken.exp !== null) {
    const expirationTime = token.accessToken.exp.getTime();
    const now = Date.now();
    const diff = expirationTime - now;
    const isExpiring = diff < expirationThreshold;
    return isExpiring;
  }
  return false;
};
exports.isTokenExpiring = isTokenExpiring;
const decodeToken = token => {
  try {
    const decoded = (0, _jwtDecode.jwtDecode)(token);
    if (typeof decoded === "object" && "exp" in decoded && typeof decoded.exp === "number") {
      return {
        data: token,
        exp: new Date(decoded.exp * 1000),
        isLegacy: false
      };
    }
  } catch (error) {
    (0, _utils.logError)("Failed to decode token:", error);
  }
  return {
    data: null,
    exp: null,
    isLegacy: false
  };
};
exports.decodeToken = decodeToken;
const processTokens = (accessToken, refreshToken) => {
  const tokenData = emptyTokenData();
  tokenData.accessToken = decodeToken(accessToken);
  if (refreshToken !== null) {
    tokenData.refreshToken = decodeToken(refreshToken);
  }
  return tokenData;
};
exports.processTokens = processTokens;